/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_SeoInputs */

const en_svtag_seo = /** @type {(inputs: Svtag_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const ar_svtag_seo = /** @type {(inputs: Svtag_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#سيو`)
};

const bn_svtag_seo = /** @type {(inputs: Svtag_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const de_svtag_seo = /** @type {(inputs: Svtag_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const es_svtag_seo = /** @type {(inputs: Svtag_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const fr_svtag_seo = /** @type {(inputs: Svtag_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const pt_svtag_seo = /** @type {(inputs: Svtag_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const zh_svtag_seo = /** @type {(inputs: Svtag_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const tr_svtag_seo = /** @type {(inputs: Svtag_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const ru_svtag_seo = /** @type {(inputs: Svtag_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

const pl_svtag_seo = /** @type {(inputs: Svtag_SeoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SEO`)
};

/**
* | output |
* | --- |
* | "#SEO" |
*
* @param {Svtag_SeoInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_seo = /** @type {((inputs?: Svtag_SeoInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_SeoInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_seo(inputs)
	if (locale === "bn") return bn_svtag_seo(inputs)
	if (locale === "de") return de_svtag_seo(inputs)
	if (locale === "es") return es_svtag_seo(inputs)
	if (locale === "fr") return fr_svtag_seo(inputs)
	if (locale === "pt") return pt_svtag_seo(inputs)
	if (locale === "zh") return zh_svtag_seo(inputs)
	if (locale === "tr") return tr_svtag_seo(inputs)
	if (locale === "ru") return ru_svtag_seo(inputs)
	if (locale === "pl") return pl_svtag_seo(inputs)
	return en_svtag_seo(inputs)
});